module.exports = __webpack_public_path__ + "media/modal-guide.6ea4ed09.mp4";